import { MedicalTypeId, MedicalTypeIds } from "@teamprevent/common/healthSurveillance/models";
import { CurrentUser } from "@teamprevent/common/auth/roles";
import Utils from "@teamprevent/common/utils";
import { WorkGroup } from "@teamprevent/common/workGroup/model";

import { CustomerState } from "../customer";

import { Location } from "redux-little-router";

export interface WorkGroupCreateModel {
    id: string;
    name: string;
    medicals: MedicalTypeId[];
    isFastTrackPitPupSpecific: boolean;
}

export interface WorkGroupEditModel {
    id: string;
    name: string;
    medicals: MedicalTypeId[];
    isFastTrackPitPupSpecific: boolean;
}

export interface WorkGroupState {
    readonly workGroups: WorkGroup[];
    readonly workGroup?: WorkGroup;
}

export const containsOnlyPitPupMedicals = (medicals: MedicalTypeId[]): boolean =>
    !medicals || Utils.IsStringArraysContentEqual(medicals, [MedicalTypeIds.AmzPitPupHealthDeclaration, MedicalTypeIds.AmzPitPupMedical]);

export type AppState = WorkGroupState & { router: Location } & { currentUser?: CurrentUser } & CustomerState;

export const areRespiratoryLevel1MedicalsValid = (medicals: MedicalTypeId[]): boolean => {
    const containsRespiratoryLevel1Medical = medicals?.some(m =>
        m === MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1 || m === MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1);

    if (containsRespiratoryLevel1Medical) {
        return medicals?.includes(MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1) &&
            medicals?.includes(MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1);
    }

    return true;
};

export const areHavsMedicalsValid = (medicals: MedicalTypeId[]): boolean => {
    const containsHavsMedical = medicals?.some(m =>
        m === MedicalTypeIds.HAVS || m === MedicalTypeIds.HAVSFaceToFace);

    if (containsHavsMedical) {
        return medicals?.includes(MedicalTypeIds.HAVS) &&
            medicals?.includes(MedicalTypeIds.HAVSFaceToFace);
    }

    return true;
};
